(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  const initCard = (card) => {
    if (!card || card.dataset.uptreand3d === '1') return;
    card.dataset.uptreand3d = '1';
    let raf = 0;

    const move = (event) => {
      if (window.innerWidth < 750) return;
      if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      const rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
      const ry = (x - .5) * 16;
      const rx = (.5 - y) * 13;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        card.style.setProperty('--up-rx', `${rx.toFixed(2)}deg`);
        card.style.setProperty('--up-ry', `${ry.toFixed(2)}deg`);
        card.style.setProperty('--up-mx', `${(x * 100).toFixed(1)}%`);
        card.style.setProperty('--up-my', `${(y * 100).toFixed(1)}%`);
        card.classList.add('is-3d-hover');
      });
    };

    const leave = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      card.classList.remove('is-3d-hover');
      card.style.setProperty('--up-rx','0deg');
      card.style.setProperty('--up-ry','0deg');
      card.style.setProperty('--up-mx','50%');
      card.style.setProperty('--up-my','50%');
    };

    card.addEventListener('pointermove', move, {passive:true});
    card.addEventListener('pointerleave', leave, {passive:true});
  };

  const scan = (root=document) => {
    if (root.matches?.('.upc')) initCard(root);
    root.querySelectorAll?.('.upc').forEach(initCard);
  };
  scan();
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if(n.nodeType===1) scan(n); }))).observe(document.documentElement,{childList:true,subtree:true});
})();
